import classNames from 'classnames';
import React, { Children } from 'react';
import { masks } from './masks';
export const PiiMask = ({ children }) => {
    const modifyChildren = (child) => {
        const className = classNames(child.props.className, ...masks.classes);
        const attributes = {};
        for (let i = 0; i < masks.attributes.length; i++) {
            attributes[masks.attributes[i]] = true;
        }
        const props = Object.assign({ className }, attributes);
        return React.cloneElement(child, props);
    };
    if (!children)
        return null;
    return Children.map(children, (child) => modifyChildren(child));
};
//# sourceMappingURL=pii-mask.js.map